import { useNavigate } from 'react-router-dom';
import Button from 'src/components/button/Button';

const PageNotFound = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col justify-center items-center h-screen w-screen">
            <strong className="text-xl">Page Not Found</strong>
            <p className="mt-2 mb-8 text-gray-darker text-center">
                The page you requested does not exist, <br />
                please go back to the log in screen
            </p>
            <Button
                className="w-48"
                text="Return to log in"
                onClick={() => navigate('/login', { replace: true })}
                primary
            />
        </div>
    );
};

export default PageNotFound;
